module.exports = __webpack_public_path__ + "img/logo-full-kelloggs-1.599ea137.png";